import styled from '@emotion/styled';
import { useDetermineMobile } from '@myrealtrip/device-detect';
import Icon from '../../../shared/designSystem/components/Icon';
import { globalVariables } from '../../../shared/designSystem/constants';
import { WeblogPageCategory, WeblogScreenName } from '../../../shared/constants/weblog';

import { sendClickLog } from '../../utils/sendClickLog';

const APP_STORE_ITEMS = [
  {
    id: 'appstore',
    label: 'App Store',
    link: 'https://itunes.apple.com/app/id1141745032',
    description: '앱스토어로 이동하기',
    icon: {
      mobile: 'ic_appstore_20x20_gray_500',
      desktop: 'ic_appstore_20x20_gray_400',
    },
  },
  {
    id: 'googleplay',
    label: 'Google Play',
    link: 'https://play.google.com/store/apps/details?id=com.mrt.ducati',
    description: '구글플레이로 이동하기',
    icon: {
      mobile: 'ic_googleplay_20x20_gray_500',
      desktop: 'ic_googleplay_20x20_gray_400',
    },
  },
];

interface AppStoreClickType {
  description: string;
  link: string;
}

export default function AppStoreList() {
  const isMobile = useDetermineMobile();

  const handleClick =
    ({ description, link }: AppStoreClickType) =>
    () => {
      sendClickLog({
        eventName: 'footer',
        screenName: WeblogScreenName.COMMON,
        pageCategory: WeblogPageCategory.COMMON,
        menuTitle: description,
        targetUrl: link,
      });
    };

  const Container = isMobile ? MobileContainer : DesktopContainer;
  const LinkItem = isMobile ? MobileLinkItem : DesktopLinkItem;
  const Link = isMobile ? MobileLink : DesktopLink;

  return (
    <Container>
      {APP_STORE_ITEMS.map(({ id, link, description, icon, label }) => {
        const iconName = isMobile ? icon.mobile : icon.desktop;

        return (
          <LinkItem key={id}>
            <Link
              href={link}
              onClick={handleClick({ description, link })}
              target="_blank"
              rel="noopener noreferrer"
              title={description}
            >
              <LinkIcon name={iconName} />
              {isMobile && <LinkLabel>{label}</LinkLabel>}
            </Link>
          </LinkItem>
        );
      })}
    </Container>
  );
}

const CommonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const MobileContainer = styled(CommonContainer)`
  width: 100%;
  justify-content: space-between;
  margin-top: 14px;
`;

const DesktopContainer = CommonContainer;

const CommonLinkItem = styled.div`
  display: flex;
  align-items: center;
`;

const MobileLinkItem = styled(CommonLinkItem)`
  width: 49%;
  height: 40px;
  margin: 0;
`;

const DesktopLinkItem = styled(CommonLinkItem)`
  height: 44px;
  margin: 0 10px;
`;

const CommonLink = styled.a`
  display: flex;
  align-items: center;
  height: 100%;
`;

const MobileLink = styled(CommonLink)`
  width: 100%;
  justify-content: center;
  border: 1px solid ${globalVariables.gray_300};
`;

const DesktopLink = CommonLink;

const LinkIcon = styled(Icon)`
  width: 20px;
  height: 20px;
`;

const LinkLabel = styled.span`
  margin-left: 8px;
  font-size: 15px;
  font-weight: 600;
  color: ${globalVariables.gray_600};
`;
